<template>
    <div>
        <center-header />
        <div class="feedback">
            <!-- 面包屑导航 -->
            <div class="breadcrumb" style="text-align: left;">
                <router-link to="/">首页</router-link>
                <span class="separator"> &gt; </span>
                <span>意见反馈</span>
            </div>

            <!-- 反馈表单 -->
            <div class="feedback-form">
                <h2 class="form-title">
                    <i class="el-icon-message"></i> 意见反馈
                </h2>
                <el-form :model="feedbackForm" ref="feedbackForm" class="form">
                    <el-form-item label="反馈类型">
                        <el-select v-model="feedbackForm.type" placeholder="请选择反馈类型" style="width: 100%;">
                            <el-option v-for="item in feedbackTypes" :key="item.aid" :label="item.title"
                                :value="item.aid"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="问题描述">
                        <el-input v-model="feedbackForm.description" type="textarea"
                            placeholder="请描述您的问题与建议，我们将为您不断改进..." rows="4" style="width: 100%;"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="upload-container">
                            <ImageUpload :image-url="feedbackForm.images" :max-files="9"
                                @upload-success="handleImgUpload($event)" />
                            <div class="upload-tips">(图片最多9张)</div>
                        </div>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" class="submit-btn" @click="submitFeedback">
                            提交反馈
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 反馈记录 -->
            <div class="feedback-records">
                <h2 class="records-title">
                    <i class="el-icon-document"></i> 反馈记录
                </h2>
                <div class="record-item" v-for="(record, index) in feedbackRecords" :key="index">
                    <div class="record-header">
                        <img :src="record.avatar" alt="用户头像" class="user-avatar">
                        <div class="record-content">
                            <div class="record-text">{{ record.body }}</div>
                            <div class="record-images" v-if="record.thumb">
                                <el-image v-for="(img, imgIndex) in record.thumb" :key="imgIndex" :src="img" alt="反馈图片"
                                    class="record-image">
                                </el-image>
                            </div>
                            <div class="record-info">
                                <span class="record-type">反馈类型: {{ record.type }}</span>
                                <span class="record-time">反馈时间: {{ record.create_time }}</span>
                            </div>
                            <div class="platform-reply" v-if="record.is_replay=='2'">
                                <p class="reply-label">平台回复:</p>
                                <p class="reply-content">{{ record.replay }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
// 导入头部和底部组件
import ImageUpload from '@/components/ImageUpload.vue'
import CenterHeader from './shopCenter/components/CenterHeader.vue'
export default {
    name: 'Feedback',
    components: {
        CenterHeader,
        ImageUpload,
    },
    data() {
        return {
            feedbackTypes: [],
            feedbackForm: {
                type: '',
                description: '',
                images: []
            },
            feedbackRecords: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
        }
    },
    mounted() {
        this.getFeedbackTypes();
        this.getFeedbackRecords();
    },
    methods: {
        // 分页大小改变时触发
        handleSizeChange(val) {
            this.pageSize = val;
            this.getFeedbackRecords();
        },
        // 分页当前页改变时触发
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getFeedbackRecords();
        },
        // 获取反馈记录
        getFeedbackRecords() {
            this.$api.getFeedbackRecords({
                user_type: '1',
                page: this.currentPage,
                list_rows: this.pageSize
            }).then(res => {
                this.feedbackRecords = res.data;
                this.total = res.total;
            }).catch(err => {
                this.$message.error(err.message);
            });
        },
        // 获取反馈类型
        getFeedbackTypes() {
            this.$api.getFeedbackTypes({
                user_type: '1'
            }).then(res => {
                this.feedbackTypes = res;
            }).catch(err => {
                this.$message.error(err.message);
            });
        },
        // 处理图片上传成功事件
        handleImgUpload(imageUrl) {
            this.feedbackForm.images = imageUrl;
        },
        submitFeedback() {
            if (!this.feedbackForm.type) {
                this.$message.warning('请选择反馈类型');
                return;
            }
            if (!this.feedbackForm.description) {
                this.$message.warning('请输入问题描述');
                return;
            }
            this.$api.submitFeedback({
                type_id: this.feedbackForm.type,
                body: this.feedbackForm.description,
                thumb: this.feedbackForm.images.length > 0 ? JSON.stringify(this.feedbackForm.images) : ''
            }).then(res => {
                this.$message.success('提交成功');
                // 刷新反馈记录
                this.getFeedbackRecords();
                // 清空表单
                this.feedbackForm = {
                    type: '',
                    description: '',
                    images: []
                };
            }).catch(err => {
                this.$message.error(err.message);
            });
        }
    }
}
</script>

<style scoped>
.feedback {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.breadcrumb {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
}

.separator {
    margin: 0 8px;
}

.feedback-form,
.feedback-records {
    background-color: #fff;
    padding: 20px 40px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
}

.form-title,
.records-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.form-title i,
.records-title i {
    margin-right: 8px;
    color: #286CED;
}

.form {
    width: 100%;
}

.upload-container {
    margin-top: 10px;
}

.upload-tip {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
}

.submit-btn {
    width: 150px;
    height: 40px;
    background-color: #286CED;
    border-color: #286CED;
}

.record-item {
    border-bottom: 1px solid #f0f0f0;
    padding: 20px 0;
}

.record-item:last-child {
    border-bottom: none;
}

.record-header {
    display: flex;
    text-align: left;
}

.user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
}

.record-content {
    flex: 1;
}

.record-text {
    font-size: 14px;
    line-height: 1.5;
    color: #333;
    margin-bottom: 15px;
}

.record-images {
    display: flex;
    margin-bottom: 15px;
}

.record-image {
    width: 80px;
    height: 80px;
    margin-right: 10px;
    border-radius: 4px;
}

.record-info {
    font-size: 12px;
    color: #999;
    margin-bottom: 10px;
}

.record-type {
    margin-right: 20px;
}

.platform-reply {
    background-color: #f5f7fa;
    padding: 10px;
    border-radius: 4px;
    margin-top: 10px;
}

.reply-label {
    font-size: 12px;
    color: #999;
    margin-bottom: 5px;
}

.reply-content {
    font-size: 12px;
    color: #333;
}

.upload-tips {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
    text-align: left;
}
</style>